export const getLocalStorage = (key, initVal) => JSON.parse(localStorage.getItem(key)) || initVal;